import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Completion } from "common/entities/Subscription";
import { Entry } from "./Entry";
import { Product } from "./Product";

export interface ISubscriptionParams {
	userIds: ID[];
	completions?: any[];
	sort?: string;
	pageSize?: number;
}

@Entity({one: "subscription", many: "subscriptions"})
export class Subscription {

	@Field()
	public id: ID;
	
	@Field()
	public completionPercentage: string;

	@Field({entity: Entry})
	public entry: Entry;

	@Field({entity: Product})
	public product: Product;

	@Field()
	public startDate: string;

	@Field()
	public score: number;

	@Field()
	public endDate: string;

	@Field()
	public completion: Completion;

	@Field()
	public completedOn: string;

	@Field()
	public timeSpent: number;

}



// WEBPACK FOOTER //
// ./src/panels/userSubscriptions/entities/Subscription.ts